import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage: themeMode === 'dark' ? 'url(/images/logos/logo_white.PNG)' : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        ></Container>
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Pedro con las Mascotas: Donde la pasión encuentra su voz
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El espacio definitivo de TNO Network dedicado a la exploración, educación y defensa del reino animal. Una plataforma donde la pasión por los animales se encuentra con la información de autoridad, ofreciendo a las marcas un entorno de máxima sensibilidad, confianza y compromiso social.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es Pedro con las Mascotas?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/pedroconlasmascotas"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/pedroconlasmascotas
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Es un ecosistema de contenido diseñado para &quot;pet lovers&quot; y familias que buscan entender y cuidar mejor a sus compañeros de vida. Desde la psicología animal hasta las últimas tendencias en bienestar, el programa transforma el amor por las mascotas en un estilo de vida responsable. Transmisión en vivo por TNO Network — <strong>consultar horario</strong>.
        </Typography>
      </Box>

      {/* Sección Pedro Scutaro */}
      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src="/images/pedro.jpg"
                alt="Pedro Scutaro - Ancla de Pedro con las Mascotas"
                sx={{
                  width: { xs: 180, sm: 220, md: 260 },
                  height: { xs: 240, sm: 300, md: 360 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
                }}
              />
              <Box
                sx={{
                  width: { xs: 180, sm: 220, md: 260 },
                  height: { xs: 240, sm: 300, md: 360 },
                  borderRadius: 2,
                  bgcolor: 'action.hover',
                  display: 'none',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography color="textSecondary">Pedro Scutaro</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRO ANCLA: PEDRO SCUTARO
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              Carisma profesional y compromiso animal
            </Typography>
            <Typography
              variant={'body1'}
              color={'textSecondary'}
            >
              <strong>Pedro Scutaro</strong> (Loc. 58.876) lidera este espacio con la autoridad de un comunicador certificado y la calidez de un defensor de los derechos animales. Su capacidad para conectar con especialistas y celebridades convierte cada programa en una experiencia inspiradora, posicionando a las marcas como aliados naturales del bienestar en el hogar.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
